import { render, staticRenderFns } from "./ComboTopicos.vue?vue&type=template&id=61476f8d&scoped=true"
import script from "./ComboTopicos.vue?vue&type=script&lang=ts"
export * from "./ComboTopicos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61476f8d",
  null
  
)

export default component.exports